import { t } from "i18next";

export const VALIDATION_PATTERNS = Object.freeze({
  POSITIVE_NUMBER: {
    value: /^(?=.*[1-9])\d*(?:\.\d{1,3})?$/,
    message: t("decarbonization.leversParametersModal.errorHandling.positiveNumberError")
  },
  DECIMAL_PERCENTAGE: {
    value: /(^100([.]0{1,2})?)$|(^\d{1,2}([.]\d{1,3})?)$/,
    message: t("decarbonization.leversParametersModal.errorHandling.percentageError")
  },
  POSITIVE_INTEGER: {
    value: /^[1-9]\d*$/,
    message: t("decarbonization.leversParametersModal.errorHandling.positiveIntegerError")
  }
});

export const indexToLetter = (index = 1) => {
  // Returns letter from the alphabet based on it's index (letter "a" as first letter has index 0)
  const first = "a".charCodeAt(0);
  return String.fromCharCode(first + index);
};

export const SUB_LEVER_PARAMETERS = Object.freeze({
  emissionsSaved: "emissionsSaved",
  totalCo2Saved: "totalCo2Saved",
  initialInvestmentPrice: "initialInvestmentPrice",
  startYear: "startYear",
  endYear: "endYear",
  operationalCostPerYear: "operationalCostPerYear"
});

export const CHART_COLORS = Object.freeze({
  "BAU": "hsla(0,100%,50%,0.62)",
  "SBTI 2030": "hsla(147,100%,35%,0.65)",
  "Net Zero 2050": "hsla(107,100%,50%,0.49)",
  "PATHWAY 1": "hsla(167,83%,60%,0.57)",
  "PATHWAY 2": "hsla(212,100%,50%,0.75)",
  "PATHWAY 3": "hsla(269,59%,52%,0.65)",
  "PATHWAY 4": "hsla(50,100%,50%,0.49)",
  "PATHWAY 5": "hsla(0,43%,55%,0.38)",
  "25% Reduction": "hsla(147,100%,35%,0.65)",
  "90% Reduction": "hsla(107,100%,50%,0.49)",
  "Supplier Emissions": "hsl(212,80%,48%)",
});

const getRandomNumber = (min, max) => {
  return min + Math.random() * (max - min);
};

export const getRandomColor = () => {
  const h = getRandomNumber(1, 360);
  const s = getRandomNumber(0, 100);
  const l = getRandomNumber(0, 100);
  return `hsl(${h},${s}%,${l}%)`;
};